<template>
  <img src="../../../assets/img/avatars/avatar7.jpg" alt="avatar7">
</template>
